import React from 'react';
import styles from './button.module.scss';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
const Button = ({ children, link, type, isExternal }) => {
  const className = classnames({
    [styles.button]: true,
    [styles[type]]: true,
  });
  if (isExternal) {
    return (
      <a className={className} href={link} target='_blank'>
        {children}
      </a>
    );
  }
  return (
    <Link className={className} to={link}>
      {children}
    </Link>
  );
};

Button.propTypes = {
  children: PropTypes.any.isRequired,
  link: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['about', 'report', 'govResponse']),
  isExternal: PropTypes.bool,
};
export default Button;



// WEBPACK FOOTER //
// ./src/components/button/button.js